import type { AvailabilityOverview, OverviewParams } from './api-types';
import { post } from './http';

export { ApiError } from './http';

export function fetchAvailabilityOverview(
  params: OverviewParams,
  signal?: AbortSignal,
): Promise<AvailabilityOverview> {
  return post<AvailabilityOverview>('/v1/availability/overview', params, signal);
}
